import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

interface IProps {
	value: any;
	setValue(value: any): void;
	keyValue: string;
}

const PeriodSelector = (props: IProps) => {
	const [startDate, setStartDate] = useState<Date | null>(null);
	const [endDate, setEndDate] = useState<Date | null>(null);

	const onAccept = (startDate: Date | null, endDate: Date | null) => {
		var eventPeriod = { ...props.value[props.keyValue] };
		var eventValue = { ...props.value };
		if (!startDate && !endDate) {
			delete eventValue[props.keyValue];
		} else {
			if (startDate) eventPeriod.start_date = Number(startDate) / 1000;
			if (endDate) eventPeriod.end_date = Number(endDate) / 1000;
			eventValue[props.keyValue] = { ...eventPeriod };
		}
		props.setValue({ ...eventValue });
	};

	useEffect(() => {
		if (props.value && props.keyValue in props.value) {
			if (
				"start_date" in props.value[props.keyValue] &&
				props.value[props.keyValue].start_date !== null
			) {
				setStartDate(new Date(props.value[props.keyValue].start_date * 1000));
			} else {
				setStartDate(null);
			}
			if (
				"end_date" in props.value[props.keyValue] &&
				props.value[props.keyValue].end_date !== null
			) {
				setEndDate(new Date(props.value[props.keyValue].end_date * 1000));
			} else {
				setEndDate(null);
			}
		} else {
			setStartDate(null);
			setEndDate(null);
		}
	}, [props, props.keyValue, props.value]);

	return (
		<LocalizationProvider dateAdapter={AdapterMoment}>
			<div className="flex justify-between gap-5 mt-3">
				<DesktopDatePicker
					label="Начало"
					className="w-[200px]"
					value={startDate}
					onChange={(val) => {
						if (val) {
							setStartDate(val);
						}
					}}
					onAccept={(val) => {
						if (val) {
							onAccept(val, endDate);
						}
					}}
					renderInput={(params) => (
						<TextField
							onKeyUp={(e) => {
								if (e.key === "Enter") {
									onAccept(startDate, endDate);
								}
							}}
							{...params}
						/>
					)}
				/>
				<DesktopDatePicker
					label="Конец"
					className="w-[200px]"
					value={endDate}
					onChange={(val) => {
						if (val) {
							setEndDate(val);
						}
					}}
					onAccept={(val) => {
						if (val) {
							onAccept(startDate, val);
						}
					}}
					renderInput={(params) => (
						<TextField
							onKeyUp={(e) => {
								if (e.key === "Enter") {
									onAccept(startDate, endDate);
								}
							}}
							{...params}
						/>
					)}
				/>
			</div>
		</LocalizationProvider>
	);
};
export default PeriodSelector;
